const HatWizardFill = () => {
  return (
    <svg
      width="15"
      height="18"
      viewBox="0 0 15 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.37357 18C2.38902 18 0.571339 16.4587 0.380089 16.2825L0 15.9345L6.83036 0H12.9512L9.15348 2.52225L14.7439 15.9375L14.3671 16.2825C14.1758 16.4587 12.3581 18 7.37357 18ZM1.92777 15.4777C2.63411 15.8527 4.30071 16.5 7.37357 16.5C10.4496 16.5 12.113 15.8528 12.8226 15.4748L7.45473 2.58375L1.92777 15.4777Z"
        fill="#9C9C9C"
      />
    </svg>
  );
};

export default HatWizardFill;
